import { coreActions } from '@sonar-software/sonar-core';
import { createAsyncSelectors } from '@lib/selectors';
import { FilterComponent } from './FilterComponent';
import { getDirectParent } from '@lib/popups';
import { getFilterId } from '@ui/table-modifier/@arch/lib';
import { OptionFilter } from '@periscopes/general/filters';
import { COPY_SPECIFIC, PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import React, { useMemo } from 'react';
import { useAction, useAsyncState, useOnMount } from '@hooks';
const selectors = createAsyncSelectors((state) => state.core.dataDictionary.objectNames.get);
export const ObjectFilter = (props) => {
    const { format, id, label, onChange, sonarObjectType, value } = props;
    const { data: objectNames } = useAsyncState(selectors);
    const loadNames = useAction(coreActions.requestGetCoreDataDictionaryObjectNames);
    useOnMount(() => {
        if (sonarObjectType) {
            loadNames({ type: sonarObjectType });
        }
    });
    const options = useMemo(() => {
        const objectMap = objectNames === null || objectNames === void 0 ? void 0 : objectNames.map((object) => {
            if (!object || object === '') {
                return {
                    label: COPY_SPECIFIC.NONE,
                    value: 'null'
                };
            }
            return {
                label: object,
                value: object
            };
        });
        return objectMap !== null && objectMap !== void 0 ? objectMap : [];
    }, [objectNames]);
    return (React.createElement(FilterComponent, Object.assign({}, props, { tagProps: {
            value: options
                .filter((option) => value === null || value === void 0 ? void 0 : value.includes(option.value))
                .map((option) => option.label)
                .join(', ')
        } }),
        React.createElement(OptionFilter, { className: 'filter', getPopupContainer: getDirectParent, id: getFilterId(id), loading: !options, maxTagCount: 'responsive', mode: 'multiple', onChange: (objectIds) => {
                onChange({
                    [id]: {
                        format,
                        value: objectIds
                    }
                });
            }, options: options !== null && options !== void 0 ? options : [], placeholder: PLACEHOLDERS_COPY.FILTER_BY(label), showArrow: true, value: value })));
};
